import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchInput from '../../../../components/inputs/SearchInput';
import styles from './MeterHeader.styles';
import FlashOnIcon from '@mui/icons-material/FlashOn';

export default function MeterHeader({ searchQuery, setSearchQuery, onSearch }) {
  return (
    <Box sx={styles.headerRow}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FlashOnIcon sx={{ ...styles.pageTitle, mr: 1 }} />
        <Typography sx={styles.pageTitle}>Meters</Typography>
      </Box>

      <SearchInput
        value={searchQuery}
        onChange={setSearchQuery}
        onSearch={onSearch}
      />
    </Box>
  );
}
